module.exports = __webpack_public_path__ + "img/morebef.96603956.png";